<template>
  <div class="copy-box">
    {{ copyText }}
    <span class="icon copy" @click="handleCopy"></span>
  </div>
</template>
<script>
export default {
  props: {
    copyText: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {}
  },
  methods: {
    handleCopy(data) {
      this.copy(this.copyText)
    },
    copy(data) {
      let elInput = document.createElement('input')
      elInput.value = data
      document.body.appendChild(elInput)
      // 选择对象
      elInput.select()
      console.log(elInput, elInput.value)
      // 执行浏览器复制命令
      this.$toast({ message: this.$t('add.text34') })
      document.execCommand('Copy')
      elInput.remove()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CopyBox.vue